import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPhone, FiMapPin, FiTrendingUp } = FiIcons;

const channels = [
  { icon: FiPhone, label: 'Phone calls', previous: 137, current: 165, change: '+20%', color: '#f8b86a' },
  { icon: FiMapPin, label: 'Direction requests', previous: 146, current: 172, change: '+18%', color: '#a7e2be' }
];

export function ChannelPerformance() {
  return (
    <section className="bg-[#101c2d] py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#f8b86a]">A closer look</p>
        <h2 className="mt-4 max-w-3xl text-3xl font-black tracking-tight text-white sm:text-5xl">The actions behind the headline.</h2>
        <p className="mt-5 max-w-2xl leading-relaxed text-slate-300">The dashboard compares its current reporting period with the previous one. Calls and direction requests increased.</p>
        <div className="mt-10 grid gap-4 md:grid-cols-2">
          {channels.map((item) => (
            <div key={item.label} className="rounded-2xl border border-white/10 bg-[#19283d] p-7" style={{ borderTop: `3px solid ${item.color}` }}>
              <SafeIcon icon={item.icon} className="h-6 w-6" style={{ color: item.color }} />
              <h3 className="mt-7 font-bold text-white">{item.label}</h3>
              <div className="mt-4 flex items-end justify-between gap-3">
                <p className="text-4xl font-black text-white">{item.current}</p>
                <p className="text-sm font-bold" style={{ color: item.color }}>{item.change}</p>
              </div>
              <p className="mt-3 text-sm text-slate-400">Previous period: {item.previous}</p>
            </div>
          ))}
        </div>
        <div className="mt-5 flex flex-wrap gap-4 rounded-2xl border border-white/10 bg-[#19283d] p-6 text-sm text-slate-300">
          <SafeIcon icon={FiTrendingUp} className="h-5 w-5 shrink-0 text-[#3fc0fa]" />
          <p><strong className="text-white">Google views in the reported period:</strong> 2,496 Search views (up 33%).</p>
        </div>
      </div>
    </section>
  );
}

const keywordRows = [
  { name: 'Gel manicure', before: '37.28%', after: '50.89%' },
  { name: 'Nail shop', before: '48.52%', after: '55.03%' },
  { name: 'Nail salon with walk-ins', before: '36.09%', after: '46.75%' },
  { name: 'Walk-in nail salon', before: '39.64%', after: '43.20%' },
  { name: 'Kids pedicure', before: '5.33%', after: '10.06%' }
];

export function RankingsDetail() {
  return (
    <section className="bg-[#0b1423] py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#a7e2be]">Local search visibility</p>
        <h2 className="mt-4 max-w-3xl text-3xl font-black tracking-tight text-white sm:text-5xl">More map placements where they count.</h2>
        <p className="mt-5 max-w-2xl leading-relaxed text-slate-300">Across the audited keywords,the dashboard’s overall average map rank moved from 13.7 at baseline to 12.5 in the latest audit. A lower average rank is better.</p>
        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-[#19283d]">
          <div className="grid grid-cols-[minmax(0,1fr)_auto_auto] gap-3 bg-[#22344d] px-4 py-4 text-xs font-bold uppercase tracking-wide text-slate-300 sm:px-7">
            <span>Search term</span><span>Baseline</span><span>Latest</span>
          </div>
          {keywordRows.map((row) => (
            <div key={row.name} className="grid grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-3 border-t border-white/10 px-4 py-5 text-sm sm:px-7 sm:text-base">
              <span className="font-semibold text-white">{row.name}</span>
              <span className="text-slate-400">{row.before}</span>
              <span className="font-bold text-[#a7e2be]">{row.after}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}